import { render, staticRenderFns } from "./formInformationpay.vue?vue&type=template&id=2da260b0&scoped=true&"
import script from "./formInformationpay.vue?vue&type=script&lang=js&"
export * from "./formInformationpay.vue?vue&type=script&lang=js&"
import style0 from "./formInformationpay.vue?vue&type=style&index=0&id=2da260b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da260b0",
  null
  
)

export default component.exports